import React from 'react';
import { cn } from '@/lib/utils';
import { Inbox } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import type { EmptyStateProps } from './EmptyState.types';

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon = Inbox,
  title = 'No data found',
  description,
  action,
  actionLabel,
  onAction,
  className,
}) => (
  <div
    data-testid="empty-state"
    className={cn(
      'flex flex-col items-center justify-center py-12 px-4 text-center',
      className
    )}
  >
    <div className="w-16 h-16 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center mb-4">
      <Icon className="w-8 h-8 text-slate-400 dark:text-slate-500" strokeWidth={1.5} />
    </div>
    <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-1">
      {title}
    </h3>
    {description && (
      <p className="text-sm text-slate-500 dark:text-slate-400 max-w-sm mb-4">
        {description}
      </p>
    )}
    {(action || onAction) && (
      <Button
        data-testid="empty-state-action"
        variant="secondary"
        onClick={onAction}
      >
        {actionLabel || 'Take action'}
      </Button>
    )}
  </div>
);
